import Select from "react-select";

export default function ProvinceSelect({
  provinces,
  provinceId,
  setProvinceId,
  setCityId,
  form,
  setForm,
  errors,
}) {
  const options = (provinces || []).map((p) => ({
    value: p.id,
    label: p.title,
  }));

  const handleChange = (selected) => {
    const id = selected ? selected.value : "";
    setProvinceId(id);
    setCityId("");
    setForm({
      ...form,
      provinceId: id,
      cityId: "",
    });
  };

  const isMobile = window.innerWidth <= 992;
  const selectStyle = {
    control: (base, state) => ({
      ...base,
      width: isMobile ? "100%" : "100%",
      height: 54,
      minHeight: 54,
      borderRadius: 12,
      fontFamily: "IRANSansBold",
      borderColor: state.isFocused ? "#95b73c" : "#d1d5db",
      boxShadow: state.isFocused
        ? "0 0 0 4px rgba(190, 230, 142, 0.12)"
        : "none",
      color: "#696969",
      "&:hover": {
        borderColor: "#95b73c",
      },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#95b73c"
        : state.isFocused
          ? "#ecfdf5"
          : "#fff",

      color: state.isSelected ? "#fff" : "#333",
    }),

    valueContainer: (base) => ({
      ...base,
      height: 54,
      padding: "0 12px",
      fontFamily: "IRANSansBold",
    }),

    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
      color: "#696969",
      fontFamily: "IRANSansBold",
    }),

    indicatorsContainer: (base) => ({
      ...base,
      height: 54,
    }),

    placeholder: (base) => ({
      ...base,
      color: "#696969",
      fontSize: 15,
    }),

    singleValue: (base) => ({
      ...base,
      fontSize: 15,
      color: "#696969",
    }),
  };

  return (
    <div className="form-group">
    
      <Select
        styles={selectStyle}
        options={options}
        value={options.find((opt) => opt.value === provinceId) || null}
        onChange={handleChange}
        placeholder="انتخاب استان"
        isClearable
      />
    </div>
  );
}
